import { render, staticRenderFns } from "./teaser.vue?vue&type=template&id=28f95e3e&scoped=true"
import script from "./teaser.vue?vue&type=script&lang=js"
export * from "./teaser.vue?vue&type=script&lang=js"
import style0 from "./teaser.vue?vue&type=style&index=0&id=28f95e3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f95e3e",
  null
  
)

export default component.exports